import PropTypes from 'prop-types';
import React from 'react';
import LinesEllipsisLoose from 'react-lines-ellipsis/lib/loose';
import Cell from './Cell';
const TextCell = /*#__PURE__*/React.memo(_ref => {
  let {
    children,
    maxLines,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Cell, props, /*#__PURE__*/React.createElement(LinesEllipsisLoose, {
    text: children,
    maxLine: maxLines,
    lineHeight: 14 * 1.15
  }));
});
TextCell.propTypes = {
  maxLines: PropTypes.number,
  children: PropTypes.any.isRequired
};
TextCell.defaultProps = {
  maxLines: 2
};
TextCell.displayName = 'TextCell';
export default TextCell;